import useInbox from "../useInbox"
import { convertEpochToDateDMY } from "@egovernments/digit-ui-module-obps/src/utils";

const useForm26Inbox = ({ tenantId, filters, config }) => {
    let citytenantId = Digit.ULBService.getCurrentTenantId();
    const {applicationStatus, mobileNumber, applicationNumber, sortBy, sortOrder, locality, uuid, limit, offset } = filters
    const USER_UUID = Digit.UserService.getUser()?.info?.uuid;
    const tcpBussinessIds = ["BPA_FORM11", "BPA_TCPBBNDA_FORM11","BPA", "BPA_TCPBBNDA" , "BPA_FORM26","BPA_TCPBBNDA_FORM26"]
    const udBussinessIds = ["BPA_UDSHIMLA_FORM11","BPA_UDSOLAN_FORM11",
    "BPA_UDTHEOG_FORM11","BPA_UDARKI_FORM11","BPA_UDPARWANOO_FORM11","BPA_UDSOLAN",
    "BPA_UDPARWANOO", "BPA_UDARKI","BPA_UDTHEOG", "BPA_UDSHIMLA","BPA_UDSHIMLA_FORM26",
    "BPA_UDSOLAN_FORM26","BPA_UDTHEOG_FORM26","BPA_UDARKI_FORM26", "BPA_UDPARWANOO_FORM26"]
    const BussinessIds = citytenantId.includes("ud") ? udBussinessIds : tcpBussinessIds
   const _filters = {
        tenantId,
		processSearchCriteria: {
            moduleName: "bpa-services",
			businessService: BussinessIds,
            ...(applicationStatus?.length > 0 ? {status: applicationStatus} : {}),
            ...(uuid && Object.keys(uuid).length > 0 ? {assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""} : {}),
        },
		moduleSearchCriteria: {
            ...(mobileNumber ? {mobileNumber}: {}),
            ...(applicationNumber ? {applicationNumber} : {}),
            ...(sortBy ? {sortBy} : {}),
            ...(sortOrder ? {sortOrder} : {}),
            ...(locality?.length > 0 ? {locality: locality.map((item) => item.code.split("_").pop()).join(",")} : {}),
        },
        limit,
        offset
    }

    return useInbox({tenantId, filters: _filters, config:{
        select: (data) =>({
            statuses: data.statusMap,
           table: data?.items.map( application => ({
                applicationId: application.businessObject.applicationNo,
                date: convertEpochToDateDMY(application.businessObject.auditDetails.createdTime),
                businessService: application.businessObject.businessService,
                locality: `${application.businessObject?.tenantId?.toUpperCase()?.split(".")?.join("_")}_REVENUE_${application.businessObject?.landInfo?.address?.locality?.code.split('.')?.[1]?.toUpperCase()}`,
                status: application.businessObject.status,
                owner: application.businessObject?.landInfo?.owners?.[0]?.name,
                dairyNo: application?.businessObject?.tcpDairyNumber,
                applicationType: application?.businessObject?.applicationType,
                userPhoto:application.businessObject?.landInfo?.owners?.[0]?.photo,
                sla: Math.round(application.ProcessInstance?.businesssServiceSla / (24 * 60 * 60 * 1000)),
                stateSla: Math.round(application.ProcessInstance?.stateSla / (24 * 60 * 60 * 1000))
            })),
            totalCount: data.totalCount
        }),
        ...config
    }})
}

export default useForm26Inbox